class ENV {
    static REACT_APP_FIREBASE_API_KEY = ''
  
    static REACT_APP_BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : '/api'
    // static REACT_APP_BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : '/api'
  
    static REACT_APP_FRONTEND_BASE_URL =
      process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://hmzones.com'
  }
  export default ENV
  